export default __webpack_public_path__ + "2c681856d877cb5a70edfe0e99a0cdd3.png";